export default "__VITE_ASSET__Du8SF32s__"